import React from 'react';
import { Container, Draggable } from 'react-smooth-dnd';
import { withRouter } from 'react-router';
import Icons from "../../../../Components/Icons/Icons";
import DrillDown from '../../../../Components/DrillDown';
import { checkViolationsExist,getViolationsMsg } from '../../../../Utils/CommonFunctions';

const FieldContent = (props) => {
	const {addNewRow,deleteRow,payload,onDrop,variableList,drillDownChangeHandler,valueChangeHandler,
			toggleCalculation,violations,windowFields} = props;
	const {excel_template_fields} = payload;

	const checkConditionViolations = (ind,name) => {
		const violKey = 'excel_template_field['+ind+'].'+name+'';
		return checkViolationsExist(violKey,violations);
	}

	const getConditionViolations = (ind,name) => {
		const violKey = 'excel_template_field['+ind+'].'+name+'';
		return getViolationsMsg(violKey,violations);
	}
	// let obj = {};
	// console.log(windowFields);
	return (
		<div className="table_Box dataTables_wrapper">
			<div className="table_Header">

				
				<div className="d-flex align-items-center justify-content-between border-bottom pt-1 pb-2">
					<div className="ml-md-auto py-2 py-md-0">
						<a className="text-info textUnderline cursor-pointer pr-2" onClick={addNewRow}>
							<Icons iconType="IconPlus" size={18} color={'#17a2b8'}/>
							<span className="pl-1"> Add Row </span>
						</a>
					</div>
				</div>
				
				<table className="table table-striped mx-2 mb-0">
					<thead className="">
						<tr>
							<th style={{"width": "10%"}}> <span> Action  </span> 
							</th>
							<th style={{"width": "20%"}}> Fields </th>
							<th style={{"width": "20%"}}> Display Value </th>
							<th style={{"width": "20%"}}> Value Expression </th> 
							<th style={{"width": "20%"}}> Default Value </th> 
						</tr>
					</thead>
				</table>
			</div>

			<div className="table_Body p-2">
				<div className="card mb-0 shadow-none">
					<div className="card-body p-0">
						<div className="table-responsive" style={{"overflow":"inherit"}}>
							<div className="dataTables_wrapper importTable">
								<table className="table table-striped">
								<tbody>
								<Container onDrop={onDrop}>
								{
									excel_template_fields && Array.isArray(excel_template_fields) && excel_template_fields.length > 0 ?
										excel_template_fields.map((item,ind) => {
											//console.log('item.window_field',item.window_field)
											return (
												<Draggable key={ind}>
													<tr key={ind} style={{"width":"100%","display":"inline-table"}}>
											 		<td style={{"width": "10%"}}>
											 			<a className="p-1 cursor-pointer" onClick={e=>deleteRow(ind)}><span className="svgDelete"><Icons iconType="Delete" /></span>&nbsp;</a>
											 		</td>
											 		<td style={{"width": "20%"}} className={checkConditionViolations(ind,'window_field_id') === true ? "has-error" : ""}>
												      	<div className="w-100 position-relative " >
													         <DrillDown selectedValue={item.window_field} drillId={"drill"+ind} 
													         	fieldDetails={windowFields}
																addExtraFields={variableList} 
																selectHandler={e=>drillDownChangeHandler(e,ind)} 
																isConditionApplied={true}
																filterWindow={true}
																isLookupSelect={false}
															/>
												      	</div>
												      	{ checkConditionViolations(ind,'window_field_id') === true ? 
						                                    <label className="error m-0">{getConditionViolations(ind,'window_field_id')}</label>
						                                    : null
						                                }
												   	</td>
												   	<td style={{"width": "20%"}} className={checkConditionViolations(ind,'column_name') === true ? "has-error" : ""}>
												      <div className="position-relative p-0 d-flex text-small cursor-pointer" >
												         <input type="text" name="column_name" 
												         	className="form-control" 
												         	value={item.column_name}
												         	onChange={e=>valueChangeHandler(e,ind)} />
												      </div>
												      { checkConditionViolations(ind,'column_name') === true ? 
						                                    <label className="error m-0">{getConditionViolations(ind,'column_name')}</label>
						                                    : null
						                                }
												   	</td>
												   	<td style={{"width": "20%"}}>
											      	<div className="input-group">
												         <input type="text" className="form-control" title={item.value_expression} value={item.value_expression} disabled={true} style={{"height":"calc(2rem + 2px)"}} />
												         <div className="input-group-append cursor-pointer" onClick={e=>toggleCalculation(ind)}>
												            <span className="input-group-text" data-toggle="modal" data-target="#assignVariables" title="Advance Calculation">
												            	<Icons iconType={item.value_expression === "" ? "AdvanceCalculation" : "AdvanceCalculationEdit"} />
												            </span>
												         </div>
												      </div>
												   	</td>
												   	<td style={{"width": "20%"}}>
												      <div className="input-group">
												         <input placeholder="Replace empty value" name="default_value" value={item.default_value} className="form-control" onChange={e=>valueChangeHandler(e,ind)}/>
												         {/*<div className="input-group-append"> <a className="input-group-text"><i className="fas fa-info"></i></a></div>*/}
												      </div>
												   	</td>
												   </tr>
											   </Draggable>
											)
										})
										: <tr style={{"width":"100%","display":"inline-table"}}>
									 		<td className="text-center" colSpan="5">
									 			 No Record exists 
									 		</td>
										  </tr>
								}
								</Container>
								</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="table_Footer" style={{"height": "45px"}}>
				 
				<div className="btn-group ml-md-auto py-2 py-md-0"> 
					{/*<a className={profile_id !== '' && layout_id!=='' ? "btn third_bg" : "hide"} onClick={getMappingData}>
						Auto Generate  
					</a>*/}
				 
			 
					{/*<a className={layout_id!=='' ?  "btn primary_bg":"hide"} onClick={addNewRow}>*/}
					<a className="text-info textUnderline cursor-pointer pr-2" onClick={addNewRow}>
						<Icons iconType="IconPlus" size={18}  color={'#17a2b8'}/>
						<span className="pl-1"> Add Row </span> 
					</a>
				</div>
				 
			</div>

		</div>
	)
}

export default withRouter(FieldContent);